import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { IBankAccount } from '../../../../shared/model/bank-account.model';
import { IImportSettingsWibSftp } from '../../../../shared/model/import-settings/import-settings-wib-sftp.model';
import { BankAccountService } from '../../../../shared/services/bank-account.service';
import { ImportSettingsWibSftpService } from '../../../../shared/services/import-settings/import-settings-wib-sftp.service';

@Component({
  selector: 'app-import-settings-wib-sftp',
  templateUrl: './import-settings-wib-sftp.component.html',
  styleUrls: ['./import-settings-wib-sftp.component.scss']
})
export class ImportSettingsWibSftpComponent implements OnInit {

  @Input()
  public bankAccount!: IBankAccount;

  public form = new FormGroup({
    host: new FormControl('', Validators.required),
    port: new FormControl('', Validators.required),
    username: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
    folder: new FormControl({ value: '', disabled: true }, Validators.required),
  });

  constructor(
    private bankAccountService: BankAccountService,
    private importSettingsWibSftpService: ImportSettingsWibSftpService,
    private router: Router,
  ) { }

  public ngOnInit(): void {
    this.importSettingsWibSftpService.get(this.bankAccount.id).subscribe((settings) => {
      this.form.patchValue(settings);
    });
  }

  public save(): void {
    if (this.form.valid) {
      const settings = this.parseSettings();
      const bankAccountId = this.bankAccount.id;
      const saveBankAccount = this.bankAccountService.update(this.bankAccount);
      const saveSettings = this.importSettingsWibSftpService.save(bankAccountId, settings);
      Promise.all([
        saveBankAccount,
        saveSettings,
      ]).then(() => {
        this.router.navigate(['/bank-accounts', bankAccountId]);
      });
    }
  }

  private parseSettings(): IImportSettingsWibSftp {
    return {
      host: this.form.get('host')?.value,
      port: this.form.get('port')?.value,
      username: this.form.get('username')?.value,
      password: this.form.get('password')?.value,
      folder: this.form.get('folder')?.value,
    };
  }

}
